var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "table-cell",
    class: [_vm.selected ? 'selected' : '', _vm.customClass],
    style: ({
      width: _vm.widget.options.cellWidth + '!important' || '',
      height: _vm.widget.options.cellHeight + '!important' || '',
      'word-break': !!_vm.widget.options.wordBreak ? 'break-all' : 'normal'
    }),
    attrs: {
      "colspan": _vm.widget.options.colspan || 1,
      "rowspan": _vm.widget.options.rowspan || 1
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectWidget(_vm.widget)
      }
    }
  }, [_c('draggable', _vm._b({
    staticClass: "draggable-div",
    attrs: {
      "list": _vm.widget.widgetList,
      "handle": ".drag-handler",
      "move": _vm.checkContainerMove
    },
    on: {
      "end": function (evt) { return _vm.onTableDragEnd(evt, _vm.widget.widgetList); },
      "add": function (evt) { return _vm.onTableDragAdd(evt, _vm.widget.widgetList); },
      "update": _vm.onTableDragUpdate
    }
  }, 'draggable', {
    group: 'dragGroup',
    ghostClass: 'ghost',
    animation: 200
  }, false), [_c('transition-group', {
    staticClass: "form-widget-list",
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_vm._l((_vm.widget.widgetList), function(subWidget, swIdx) {
    return [('container' === subWidget.category) ? [_c(subWidget.type + '-widget', {
      key: subWidget.id,
      tag: "component",
      attrs: {
        "widget": subWidget,
        "designer": _vm.designer,
        "parent-list": _vm.widget.widgetList,
        "index-of-parent-list": swIdx,
        "parent-widget": _vm.widget
      }
    })] : [_c(subWidget.type + '-widget', {
      key: subWidget.id,
      tag: "component",
      attrs: {
        "field": subWidget,
        "designer": _vm.designer,
        "parent-list": _vm.widget.widgetList,
        "index-of-parent-list": swIdx,
        "parent-widget": _vm.widget,
        "design-state": true
      }
    })]]
  })], 2)], 1), _vm._v(" "), (_vm.designer.selectedId === _vm.widget.id && _vm.widget.type === 'table-cell') ? _c('div', {
    staticClass: "table-cell-action"
  }, [_c('i', {
    staticClass: "el-icon-back",
    attrs: {
      "title": _vm.i18nt('designer.hint.selectParentWidget')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectParentWidget()
      }
    }
  }), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "size": "small"
    },
    on: {
      "command": _vm.handleTableCellCommand
    }
  }, [_c('i', {
    staticClass: "el-icon-menu",
    attrs: {
      "title": _vm.i18nt('designer.hint.cellSetting')
    }
  }), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "insertLeftCol"
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.insertColumnToLeft')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "insertRightCol"
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.insertColumnToRight')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "insertAboveRow"
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.insertRowAbove')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "insertBelowRow"
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.insertRowBelow')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "mergeLeftCol",
      "disabled": _vm.mergeLeftColDisabled,
      "divided": ""
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.mergeLeftColumn')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "mergeRightCol",
      "disabled": _vm.mergeRightColDisabled
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.mergeRightColumn')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "mergeWholeRow",
      "disabled": _vm.mergeWholeRowDisabled
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.mergeEntireRow')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "mergeAboveRow",
      "disabled": _vm.mergeAboveRowDisabled,
      "divided": ""
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.mergeRowAbove')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "mergeBelowRow",
      "disabled": _vm.mergeBelowRowDisabled
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.mergeRowBelow')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "mergeWholeCol",
      "disabled": _vm.mergeWholeColDisabled
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.mergeEntireColumn')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "undoMergeRow",
      "disabled": _vm.undoMergeRowDisabled,
      "divided": ""
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.undoMergeRow')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "undoMergeCol",
      "disabled": _vm.undoMergeColDisabled
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.undoMergeCol')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "deleteWholeCol",
      "disabled": _vm.deleteWholeColDisabled,
      "divided": ""
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.deleteEntireCol')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "deleteWholeRow",
      "disabled": _vm.deleteWholeRowDisabled
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.deleteEntireRow')))])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.designer.selectedId === _vm.widget.id && _vm.widget.type === 'table-cell') ? _c('div', {
    staticClass: "table-cell-handler"
  }, [_c('i', [_vm._v(_vm._s(_vm.i18nt('designer.widgetLabel.' + _vm.widget.type)))])]) : _vm._e()], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acb2d9ca","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/form-widget/container-widget/table-cell-widget.vue
// module id = null
// module chunks = 